import {
  EyeTwoTone,
  EyeInvisibleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import Helpers from "@utils/Helpers";
import { Input, Button, Tooltip } from "antd";
import Validates from "@utils/Validates";
import { useState } from "react";

interface IPasswordForm {
  formSignUp: any;
  setCurrentStep: (step: number) => void;
  handleSetFormSignUp: any;
  confirmPassword: string;
  setConfirmPassword: (pass: string) => void;
}

const PasswordForm: React.FC<IPasswordForm> = ({
  formSignUp,
  setCurrentStep,
  handleSetFormSignUp,
  confirmPassword,
  setConfirmPassword,
}) => {
  const [passwordFocused, setpasswordFocused] = useState(false);
  const [confirmFocused, setconfirmFocused] = useState(false);

  const comparePassword = (): boolean => {
    return formSignUp.password === confirmPassword;
  };

  const passwordIsValid = Validates.validateValidPassword(formSignUp.password);

  const nextStep = () => {
    if (!comparePassword()) {
      Helpers.notification.warning("Passwords do not match.");
      return;
    }
    if (!passwordIsValid) {
      Helpers.notification.warning("Password is not valid.");
      return;
    }
    setCurrentStep(3);
  };

  const hint = (
    <span>
      Password must be at least 8 characters long and include at least one
      UPPERCASE letter, one lowercase letter, one number, and one special
      character.
    </span>
  );

  const passwordError =
    passwordFocused && !passwordIsValid
      ? "Invalid password format. Click the 'i' icon above for instructions."
      : null;

  const confirmError =
    confirmFocused && !comparePassword() ? "Passwords do not match." : null;

  return (
    <div className="PasswordForm">
      <div className="forn-group mb-3">
        <div className="title">
          Password <span className="text-danger">*</span>{" "}
          <Tooltip placement="right" title={hint}>
            <InfoCircleOutlined />
          </Tooltip>
        </div>
        <Input.Password
          variant="filled"
          className="ant-form"
          autoComplete="off"
          value={formSignUp.password}
          onChange={(e) => handleSetFormSignUp("password", e.target.value)}
          onBlur={() => setpasswordFocused(true)}
          status={passwordError ? "error" : ""}
          iconRender={(visible) =>
            visible ? (
              <EyeTwoTone twoToneColor="#79ad7f" />
            ) : (
              <EyeInvisibleOutlined />
            )
          }
        />
        {passwordError && (
          <div style={{ color: "red", marginTop: 4 }}>{passwordError}</div>
        )}
      </div>

      <div className="forn-group">
        <div className="title">
          Confirm Password <span className="text-danger">*</span>
        </div>
        <Input.Password
          variant="filled"
          className="ant-form"
          autoComplete="off"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          onBlur={() => setconfirmFocused(true)}
          status={confirmError ? "error" : ""}
          iconRender={(visible) =>
            visible ? (
              <EyeTwoTone twoToneColor="#79ad7f" />
            ) : (
              <EyeInvisibleOutlined />
            )
          }
        />
        {confirmError && (
          <div style={{ color: "red", marginTop: 4 }}>{confirmError}</div>
        )}
      </div>

      <Button className="next-btn" onClick={nextStep}>
        Next
      </Button>
      <Button className="prev-btn" onClick={() => setCurrentStep(1)}>
        Back
      </Button>
    </div>
  );
};

export default PasswordForm;
